import { StyledTextLink, StyledTextLinkBackground } from './TextLink.styles.js';
import { type TextLinkProps } from './types.js';

export const TextLink = ({
  children,
  elementRef,
  onClick,
  rel,
  target,
  textStyle = 'buttonLabelRegular',
  to,
  underlineColor,
}: TextLinkProps) => {
  return (
    <StyledTextLinkBackground
      onClick={onClick}
      ref={elementRef}
      rel={rel}
      target={target}
      to={to}
    >
      <StyledTextLink
        as="span"
        textStyle={textStyle}
        underlineColor={underlineColor}
      >
        {children}
      </StyledTextLink>
    </StyledTextLinkBackground>
  );
};
